export type ToastKind = 'info' | 'error' | 'success';

let host: HTMLDivElement | null = null;

function ensureHost(): HTMLDivElement {
  if (host) return host;
  const root = document.createElement('div');
  root.className = 'layer toast-host';
  document.body.appendChild(root);
  host = root;
  return root;
}

export function showToast(text: string, kind: ToastKind = 'info', durationMs = 2400): void {
  const root = ensureHost();
  const el = document.createElement('div');
  el.className = `toast toast-${kind}`;
  el.textContent = text;
  root.appendChild(el);
  requestAnimationFrame(() => el.classList.add('show'));
  setTimeout(() => {
    el.classList.remove('show');
    setTimeout(() => el.remove(), 240);
  }, durationMs);
}

export function showFatal(text: string): void {
  const root = ensureHost();
  root.innerHTML = '';
  const el = document.createElement('div');
  el.className = 'toast-fatal';
  el.innerHTML = `<div class="toast-fatal-icon">⚠️</div><div class="toast-fatal-text">${text}</div>`;
  root.appendChild(el);
}
